module.exports = __webpack_public_path__ + "img/milho.c56a3790.svg";